import { network } from 'services/network';

export const setSubProgramPreferenceP6ExcelExport = (params) => {
    return network.post('api/bo/setSubProgramPreferenceP6ExcelExport', params).then((response) => response.data);
};
